<template>
  <div class="home">
    <report-list v-if="false" />
    <report-detail v-if="false" />
    <fc-button />
  </div>

</template>

<script>
export default {
  name: 'Home',
  components: {

  },
  methods: {

  }
}
</script>
